import React, { useState, useEffect, useRef } from 'react';
import { isSbsApp } from '../../../common/utils/passUtil';

export default function ChannelTab({ channels, onChannelChange }) {
  const [isRender, setIsRender] = useState(false);
  const [currentChannelId, setCurrentChannelId] = useState('');

  const scrollRef = useRef(null);
  const activeTabRef = useRef(null);

  useEffect(() => {
    setIsRender(true);
  }, []);

  useEffect(() => {
    const path = window.location.pathname;
    const channelIdFromUrl = path.split('/').pop();
    const isValidChannelId = channels.some(
      (channel) => channel.channelid === channelIdFromUrl
    );
    setCurrentChannelId(isValidChannelId ? channelIdFromUrl : '');
  }, [channels]);

  useEffect(() => {
    if (activeTabRef.current && scrollRef.current) {
      const scrollContainer = scrollRef.current;
      const activeTab = activeTabRef.current;

      // 스크롤 컨테이너의 너비와 전체 스크롤 가능한 너비 계산
      const containerWidth = scrollContainer.offsetWidth;
      const scrollWidth = scrollContainer.scrollWidth;

      // 활성화된 탭의 왼쪽 위치와 너비
      const tabLeft = activeTab.offsetLeft;
      const tabWidth = activeTab.offsetWidth;

      // 스크롤 위치 계산
      let scrollLeft = tabLeft - (containerWidth - tabWidth) / 2;
      scrollLeft = Math.max(
        0,
        Math.min(scrollLeft, scrollWidth - containerWidth)
      );

      scrollContainer.scrollTo({
        left: scrollLeft,
        behavior: 'smooth',
      });
    }
  }, [currentChannelId]);

  const handleClick = (channelId) => {
    setCurrentChannelId(channelId);
    if (onChannelChange) {
      onChannelChange(channelId);
    }
  };

  return (
    isRender && (
      <div
        className="tabList_w01"
        style={{ position: 'sticky', top: '0', zIndex: '1000' }}
      >
        <style>{`
          body {
            overflow-x: visible;
          }
        `}</style>
        <div className="tabList_inner" ref={scrollRef}>
          {channels
            .sort((a, b) =>
              a.channelid === currentChannelId
                ? -1
                : b.channelid === currentChannelId
                ? 1
                : 0
            )
            .map((channel, index) => (
              <a
                key={channel.channelid || index}
                className={`btnLine01 ${
                  channel.channelid === currentChannelId ? 'active' : ''
                }`}
                onClick={() => handleClick(channel.channelid)}
                ref={
                  channel.channelid === currentChannelId ? activeTabRef : null
                }
              >
                <span>{channel.desc || channel.channelid}</span>
              </a>
            ))}
        </div>
      </div>
    )
  );
}
